import { Button, IconButton, Menu, MenuItem, MenuList } from "@material-ui/core";
import React, { Component } from "react";
import Avatar from "react-avatar";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import LogOut from "./logOut";

class AccountStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAccountMenu: false,
      isLoading: false
    };
  }


  handleOpenAccountMenu = (event) => {
    this.setState({ openAccountMenu: event.currentTarget });
  }

  redirection = () => {
    if (!this.props.isLoggedIn && this.props.props.location.search !== "?redirect=/account") {
      if (this.props.props.location.pathname == '/resetPassword') {
        return window.location.origin + `/signIn`;
      } 
      else {
        return `signIn?redirect=` + encodeURIComponent(`${this.props.props.location.pathname}${this.props.props.location.search
          }`);
      }
    }
    else return window.location.origin + "/store/account";
  };

  handleLogOut = event => {
    event.preventDefault();
    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "logout", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .then(result => {
        if (result.Result === "Success") {
          this.props.userHasAuthenticated(false, undefined);
        }
        this.setState({ isLoading: false });
      })
      .catch(error => {
        console.error(error);
        this.props.handleServerError(true);
      });
  };

  render() {
    return window.location.pathname !== "/store/signIn" ? (
      <React.Fragment>
        {this.props.isLoggedIn ? 
          <NavDropdown
            title={this.props.firstName.toUpperCase().charAt(0) + this.props.lastName.toUpperCase().charAt(0)}
            id="accountTitle">
            <NavDropdown.Item href={this.redirection()} id="accountDetailsBox" className="accountDetailsMenu">
              <Avatar
                size="65"
                id="avatarPicture"
                email={this.props.userName}
                name={this.props.firstName + " " + this.props.lastName}
                className="accountDetailsMenuAvatar"
                round={true}
              />
              <div id="accountNameDetailsDivId" className="accountNameDiv">
                <div id="accountNameId" className="text-capitalize nameClass">
                  {this.props.firstName + " " + this.props.lastName}
                </div>

                <div id="accountDetailsEmailId" style={{ fontSize: '12px', color: '#767676' }}>{this.props.userName}</div>
              </div>
            </NavDropdown.Item>
            <NavDropdown.Divider id="firstDropDownDeviderId" className="acountNameDividerClass" />
            <NavDropdown.Item id="changePasswordAccountDropDown" className="dropDownItemClass" href={window.location.origin + "/store/account/changePassword"}>
              Change Password
            </NavDropdown.Item>
            <NavDropdown.Item id="privacyPrefrencesAccountDropDown" className="dropDownItemClass" href={window.location.origin + "/store/account/privacy"}>
              Privacy Preferences
            </NavDropdown.Item>
            <NavDropdown.Item id="deleteAccountDropDown" className="dropDownItemClass" href={window.location.origin + "/store/account/deleteAccount"}>
              Delete Account
            </NavDropdown.Item>
            <NavDropdown.Item id="logOutdccountDropDown" className="dropDownItemClass" onClick={this.handleLogOut}>
              Log Out
            </NavDropdown.Item>
          </NavDropdown> :
          <Link
            id="signInTopAccountButton"
            to={this.redirection()}
            className="btn btn-outline-primary text-capitalize"
          >
            Login
          </Link>
        }

      </React.Fragment>
    ) : null;
  }
}

export default AccountStatus;
